import React, { Component } from 'react';
import { connect } from 'react-redux';
import styled from '@emotion/styled';

import { VerticalFlexContainer } from './ModalContainers/ModalContainers';
import Button from '../Button';
import HandOffLink from '../../../utils/urls/HandOffLink';
import colors from '../../../styling/colors';
import { paragraphXSmall } from '../../../styling/mixins/typography';

const FullHeightVerticalFlexContainer = styled(VerticalFlexContainer)`
  height: 100%;
`;

const PreviewIFrame = styled.iframe`
  width: 100%;
  height: 100%;
  border: 0;
`;

const ContentArea = styled.div`
  width: 100%;
  border-top: 1px solid ${colors('alto')};
  color: ${colors('lapel')};
  padding: 1.25rem 0 2rem;
  text-align: center;
`;

const Description = styled.p`
  ${paragraphXSmall};
  margin-bottom: 0.75rem;
`;

const StyledHandOffLink = styled(HandOffLink)`
  color: ${colors('gatsby')};
  text-decoration: underline;
  cursor: pointer;
`;

/**
 * PreviewModal
 *
 * @description
 * Shows the preview modal with an iFrame showing the preview of the selected card
 *
 * @property {function} onClose - function to close the modal
 * @property {string} url - URL to the iframe to display
 */
export class PreviewModal extends Component {
  render() {
    const { previewURL, customizeURL, isMobile } = this.props;
    const CustomizeLink = (
      <StyledHandOffLink
        identifier="preview-customize-button"
        href={customizeURL}
        isMobile={isMobile}
        authRequired={true}
      >
        customize
      </StyledHandOffLink>
    );

    return (
      <FullHeightVerticalFlexContainer>
        <PreviewIFrame
          ref={iframe => {
            if (iframe !== null) {
              // set focus immediately in case it just works (i.e. in Chrome)
              iframe.focus();

              let cycles = 0;
              let hasSetFocus = false;
              const checkInterval = setInterval(() => {
                const iframeDoc =
                  iframe.contentDocument || iframe.contentWindow.document;

                // If the iframe is ready, or we've waited a while...
                if (
                  cycles > 20 ||
                  (iframeDoc &&
                    (iframeDoc.readyState === 'interactive' ||
                      iframeDoc.readyState === 'complete'))
                ) {
                  iframe.focus();
                  if (iframeDoc) iframeDoc.body.focus();
                  hasSetFocus = true;
                }

                cycles++;

                if (hasSetFocus) {
                  clearInterval(checkInterval);
                }
              }, 250);
            }
          }}
          src={`${previewURL}`}
        />
        <ContentArea>
          <Description>
            This is a preview of the card animation. Click {CustomizeLink} to
            get started.
          </Description>
          <HandOffLink
            identifier="preview-customize-button"
            isMobile={isMobile}
            href={customizeURL}
            authRequired={true}
          >
            <Button color={'gatsby'}>Customize</Button>
          </HandOffLink>
        </ContentArea>
      </FullHeightVerticalFlexContainer>
    );
  }
}

const mapStateToProps = ({
  modals: { previewURL, customizeURL },
  env: { isMobile },
}) => ({
  previewURL,
  customizeURL,
  isMobile,
});

export default connect(mapStateToProps)(PreviewModal);
